import { render, staticRenderFns } from "./rolea.vue?vue&type=template&id=4b55fcbc&scoped=true&"
import script from "./rolea.vue?vue&type=script&lang=js&"
export * from "./rolea.vue?vue&type=script&lang=js&"
import style0 from "./rolea.vue?vue&type=style&index=0&id=4b55fcbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55fcbc",
  null
  
)

export default component.exports